import { jsx } from 'react/jsx-runtime';
import { format } from 'url';
import Link from 'next/link';
import { Children, cloneElement } from 'react';
import { useNextFlexRouter } from '../hooks/flexRouter/useNextFlexRouter.mjs';
import { stripBasePath } from '../utils/basePath.mjs';

function NextLink({
  href,
  passHref,
  children,
  ...rest
}) {
  const { basePath } = useNextFlexRouter();
  const [hrefWithoutBasePath, canUseNextRouter] = stripBasePath(href, basePath);
  if (canUseNextRouter) {
    return /* @__PURE__ */ jsx(Link, { href: hrefWithoutBasePath, passHref: true, prefetch: false, ...rest, children });
  }
  const child = Children.only(children);
  if (passHref) {
    return cloneElement(child, { href: format(href) });
  }
  return /* @__PURE__ */ jsx("a", { href: format(href), ...rest, children });
}

export { NextLink };
//# sourceMappingURL=NextLink.mjs.map
